
import React, { useEffect } from 'react';
import { documentService, windowService } from '../../utils/window.utils';
import { useLocation } from 'react-router';

interface AnchorTagProps {
  params: {
    ID: string;
  };
}
const AnchorTag = ({ params }: AnchorTagProps) => {
  const { ID } = params;
  const location = useLocation();
  useEffect(() => {
    const locationHref = windowService().location.href;
    if (locationHref.includes('#') && locationHref.split('#')[1] === ID) {
      documentService().getElementById(ID)?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.key, location.hash]);
  return (
    <div 
      id={ID} 
      style={{ 
        top: 1,
        visibility: "hidden",
      }}
    />
  );
};
export default AnchorTag;